import { Component, Input, OnInit } from '@angular/core';
import { TransitionsActions } from '../../../application-state/store/actions';
import { Observable } from 'rxjs';
import { Order } from '../../../orders/models';
import { PotentialAction } from '../../models';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../application-state/store';
import { filter, takeUntil } from 'rxjs/operators';
import { BaseOnDestroyComponent } from '../../injectables/BaseOnDestroy.component';
import { ActionBoxInputTypes } from '../../models/action-box-input-types.type';
import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'app-action-box-from-check-return-shipment-necessary',
  styleUrls: [
    './action-box-from-check-return-shipment-necessary.component.scss'
  ],
  template: `
    <div class="action-box">
      <div class="action-required-label" *ngIf="canMakeTransition">
        Aktion erforderlich
      </div>
      <div class="action-required-label bg-green" *ngIf="!canMakeTransition">
        Warte auf Zuarbeit
      </div>
      <div class="content ">
        <div class="row" *ngIf="canMakeTransition">
          <div class=" col-auto my-2 align-items-center">
            <div class="row ">
              <div class=" col-auto header">
                Müssen Datenträger an Kunden verschicken werden?
              </div>
              <div class="sub-header col-auto">
                Bitte prüfen, ob ein Rückversand zum Kunden nötig ist!
              </div>
            </div>
          </div>
          <div class="actions col my-2 text-right">
            <button
              class="decision-btn btn-wider me-3"
              mat-button
              color="green"
              (click)="handleMakeTransition()"
              [disabled]="!okAction"
            >
              <mat-icon class="me-2">local_shipping</mat-icon>
              <span>Versand nötig</span>
            </button>
            <button
              class="decision-btn btn-wider me-3"
              mat-button
              color="green"
              (click)="handleMakeTransition2()"
              [disabled]="!nokAction"
            >
              <mat-icon class="me-2">done</mat-icon>
              <span>kein Versand nötig</span>
            </button>
          </div>
        </div>
        <div class="row " *ngIf="!canMakeTransition">
          <div class=" col-auto header">Rückversand Datenträger prüfen</div>
          <div class="sub-header col-auto">
            Warte auf Entscheidung ob Datenträger an Kunden verschicken werden
            müssen
          </div>
        </div>
      </div>
      <div class="additional-content p-4" *ngIf="canMakeTransition">
        <div class="row">
          <app-order-stock-item-select-list
            [readonlyArchive]="true"
          ></app-order-stock-item-select-list>
        </div>
      </div>
    </div>
  `
})
export class ActionBoxFromCheckReturnShipmentNecessaryComponent
  extends BaseOnDestroyComponent
  implements OnInit {
  @Input() order$: Observable<Order>;
  @Input() inputType: ActionBoxInputTypes;

  order: Order;
  okAction: PotentialAction = null;
  nokAction: PotentialAction = null;

  constructor(
    private store$: Store<ApplicationState>,
    private authService: AuthService
  ) {
    super();
  }

  get canMakeTransition(): boolean {
    return (
      (this.inputType === 'order' &&
        (this.authService.isTechnician() ||
          this.authService.isLogistic() ||
          this.authService.isAccounting() ||
          this.authService.isAdmin() ||
          this.authService.isSupervisor())) ||
      false
    );
  }

  ngOnInit(): void {
    this.order$
      .pipe(
        takeUntil(this.onDestroy$),
        filter(order => !!order)
      )
      .subscribe(order => {
        this.order = order;
        this.okAction = order.potentialActions?.find(
          e =>
            e.transition.indexOf(
              'check_return_shipment_necessary_to_return_shipment'
            ) > -1 && !e.error
        );
        this.nokAction = order.potentialActions?.find(
          e =>
            e.transition.indexOf(
              'check_return_shipment_necessary_to_order_closed'
            ) > -1 && !e.error
        );
      });
  }

  handleMakeTransition(): void {
    const action = this.okAction;
    if (!action) {
      return;
    }
    const uri = `${this.order['@id']}/transitions?workflow=${action.workflow}&transition=${action.transition}`;
    const payload = {
      workflow: action.workflow,
      transition: action.transition
    };
    this.store$.dispatch(TransitionsActions.MakeTransition({ uri, payload }));
  }

  handleMakeTransition2(): void {
    const action = this.nokAction;
    if (!action) {
      return;
    }
    const uri = `${this.order['@id']}/transitions?workflow=${action.workflow}&transition=${action.transition}`;
    const payload = {
      workflow: action.workflow,
      transition: action.transition
    };
    this.store$.dispatch(TransitionsActions.MakeTransition({ uri, payload }));
  }
}
